import { AuthGuard, CanDeactivateGuard } from "@dis/auth";
import { ProjectDetailDashboardResolver } from "../dashboards/project-details-dashboard/project-detail-dashboard.resolver";
import { CollectionSelectionService } from "../layout/collection-detail-layout/collection-selection.service";
import { provideDetailLinks } from "../layout/collection-detail-layout/detail-links.service";
import { JtmsRoutes, collectionDetailLayout, tablesLayout, uuidParam, groupOverview } from "../core/routing/route-data";

export default [
  {
    path: "",
    canMatch: [AuthGuard],
    data: { navGroup: "projects" },
    children: [
      groupOverview(() => import("../feature/overviews/projects-overview").then((m) => m.ProjectsOverview)),
      {
        path: "list",
        loadComponent: tablesLayout,
        children: [
          {
            path: "",
            data: { navOrder: 1 },
            loadComponent: () =>
              import("../feature/tables/projects/projects-table.component").then((m) => m.ProjectsTable),
            title: "Projects",
          },
        ],
      },
      {
        path: "new",
        canDeactivate: [CanDeactivateGuard],
        loadComponent: () =>
          import("../jtms/1_projects/project-container/project-container.component").then(
            (m) => m.ProjectContainerComponent
          ),
        title: "New Project",
      },
      {
        // Retiring, not removed: the project-number dashboard for older legacy projects and the STAGING / TEST
        // project views. /projects/:projectNumber still reaches it through the legacy routes below.
        path: "legacy/:projectNumber",
        resolve: { projectNumber: ProjectDetailDashboardResolver },
        loadComponent: () =>
          import("../dashboards/project-details-dashboard/component/project-details-dashboard-container.component").then(
            (m) => m.ProjectDetailsDashboardContainerComponent
          ),
        title: "Project (legacy view)",
      },
      {
        // UUID only, so legacy /projects/:projectNumber (and printed /projects/<num>/<job> labels) fall through below.
        matcher: uuidParam("projectId"),
        providers: [CollectionSelectionService, provideDetailLinks("entity")],
        loadComponent: collectionDetailLayout,
        children: [
          {
            path: "",
            data: { entityType: "project" },
            loadComponent: () =>
              import("../feature/dashboards/collection-detail/views/project-detail-view-container/project-detail-view-container.component").then(
                (m) => m.ProjectDetailViewContainer
              ),
            title: "Project Details",
          },
        ],
      },
      {
        // Legacy /projects/* routes (ag-grid, table, sheets-table, :projectNumber dashboard) until redirects replace them.
        path: "",
        loadChildren: () => import("../jtms/1_projects/1-projects.routes"),
      },
    ],
  },
] satisfies JtmsRoutes;
